import React from 'react';

import { SVGPropsType } from 'src/types';

function EyeOpen(props: SVGPropsType) {
    const { fill, onClick, style, className } = props;

    return (
        <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M6 7.37143C6.55228 7.37143 7 6.92371 7 6.37143C7 5.81914 6.55228 5.37143 6 5.37143C5.44772 5.37143 5 5.81914 5 6.37143C5 6.92371 5.44772 7.37143 6 7.37143Z"
                fill={fill}
            />
            <path
                d="M6 2.37143C2.5 2.37143 0.5 6.37143 0.5 6.37143C0.5 6.37143 2.5 10.3714 6 10.3714C9.5 10.3714 11.5 6.37143 11.5 6.37143C11.5 6.37143 9.5 2.37143 6 2.37143ZM6 8.37143C4.9 8.37143 4 7.47143 4 6.37143C4 5.27143 4.9 4.37143 6 4.37143C7.1 4.37143 8 5.27143 8 6.37143C8 7.47143 7.1 8.37143 6 8.37143Z"
                fill={fill}
            />
        </svg>
    );
}

export default EyeOpen;
